
































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

@Component

export default class ComponentModalPendenciaConfirmar extends Vue {
  loadConfirmar: boolean = false

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get showModalConfirmar() {
    return this.getSolicitacaoPendenciaStore.modalSolicitacaoPendencia.confirmar
  }

  set showModalConfirmar(value: boolean) {
    this.getSolicitacaoPendenciaStore.setModalConfirmar(value)
  }

  get getPendenciaMensagem() {
    return this.getSolicitacaoPendenciaStore.pendencia.mensagens
  }

  clearMensagem() {
    this.getSolicitacaoPendenciaStore.clearMensagem()
  }

  closeModal() {
    this.loadingConfirmar = false
  }

  @Emit('confirmarPendencia')
  confirmarPendencia() {
    this.loadingConfirmar = true
  }

  @Emit('bloquearAgendamento')
  bloquearAgendamento() {}

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }
}
